import React, { useEffect, useRef, useState } from "react";
import MenuLayout from "../../layouts/MenuLayout";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { coachPaths } from "../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachList } from "../../redux/features/coach/actions/coachAction";
import Loader from "../../components/loader";
import { fetchCoachCategories } from "../../redux/features/coach/actions/authAction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { enterPrisesPaths } from "../../routes/enterprises";

const MatchTalent = () => {
  const { isLoading2, coachList } = useSelector((state) => state.coach.coach);
  const { categoryList, isLoading } = useSelector((state) => state.coach.auth);

  const user = { name: "find-a-coach", role: "coach" };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (isLoading2 || isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <MenuLayout user={user}>
        {({ openSignUp }) => (
          <>
            <section class="ct_px_40 mt-4   py-5">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-xxl-6 col-xl-6 col-md-6 mb-4 mb-md-0 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="">
                      <h2
                        class="ct_fs_50_new mb-4"
                        style={{ maxWidth: "600px" }}
                      >
                        {" "}
                        Find the <span className="ct_yellow_text">
                          Right
                        </span>{" "}
                        Fit, Fast Without Compromise
                      </h2>
                      <p
                        class="mb-0 mt-3 ct_fs_20 "
                        style={{ maxWidth: "586px" }}
                      >
                        Search by skill, experience, or availability get matched
                        with top talent in seconds.
                      </p>
                      <div className="position-relative ct_mt_30">
                        <input
                          type="text"
                          className="form-control ct_input ct_h_44 ct_input_ps_40"
                          placeholder="Search"
                        />
                        <i class="fa-solid fa-magnifying-glass ct_input_icon_left"></i>
                      </div>
                      <div class="ct_mt_30">
                        <a
                          class="ct_yellow_btn ct_yellow_btn_text_blue   px-5 ct_fit_content  "
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(coachPaths.HireTalent);
                          }}
                        >
                          Hire Talent
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xxl-6 col-xl-6 col-md-6 mb-4 mb-md-0 ps-md-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_match_talent_grid_2">
                      <img src="../assets/img/Featured_Coaches_img_80.png" />
                      <img src="../assets/img/match_talent_2_img.png" />
                      <img src="../assets/img/Featured_Coaches_img_8_hd.png" />
                      <img src="../assets/img/match_talent_4_img.png" />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 ct_py_130">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_img">
                      <img
                        src="../assets/img/founderCoaching_right_banner.png"
                        alt=""
                        style={{ objectFit: "cover", objectPosition: "right" }}
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_content">
                      <h4 class="ct_fs_24 ct_orange_text">
                        Build Your Dream Team, Smarter
                      </h4>
                      <h3 class="ct_fs_32 ct_darksky_blue_text ">
                        Your Team-Building Revolution Starts Here
                      </h3>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/ri_find-replace-fill.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Explore
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "175px" }}
                            >
                              Discover a curated network of professionals with
                              the right skills and industry expertise.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/work_icon_2.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Connect
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "205px" }}
                            >
                              Quickly match with talent aligned to your goals
                              and start meaningful conversations.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/uim_bag.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Hire
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "215px" }}
                            >
                              Onboard freelancers/ consultants seamlessly and
                              scale your team with confidence on your terms.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="ct_dark_blue_bg rounded-0 ct_py ct_search_dream_job_main">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="ct_fs_32 ct_mb_30 text-white">
                      Unlock Your Business
                    </h4>
                    <div
                      className="ct_search_dream_job_filter ct_flex_col_991"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div className="form-group position-relative">
                        <select className="form-control ct_input ct_input_ps_40 ct_h_48 ct_blue_input_bg">
                          <option>Browse by</option>
                          <option>UI/UX Design</option>
                          <option>Mobile App Development</option>
                          <option>Web Development</option>
                          <option>Copy Writing</option>
                          <option>SEO Writing</option>
                          <option>Digital Marketing</option>
                          <option>Social Media Management</option>
                          <option>Product Management</option>
                          <option>Virtual Assistant</option>
                          <option>Customer</option>
                        </select>
                        <div className="ct_input_icon_left">
                          <svg
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_30_38484)">
                              <path
                                d="M16.625 9.50104C16.625 13.4361 13.435 16.626 9.5 16.626C5.56498 16.626 2.375 13.4361 2.375 9.50104C2.375 5.56601 5.56498 2.37604 9.5 2.37604C13.435 2.37604 16.625 5.56601 16.625 9.50104Z"
                                stroke="#FFB703"
                                stroke-width="1.18674"
                                stroke-linejoin="round"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M12.5117 7.46502C13.0258 6.60825 13.2828 6.17985 13.1674 5.97846C13.1325 5.91738 13.0819 5.86674 13.0208 5.83176C12.8194 5.71638 12.391 5.97342 11.5342 6.48749L8.53282 8.28831C8.4653 8.32879 8.43161 8.34903 8.40282 8.37519C8.39317 8.38389 8.38404 8.39302 8.37542 8.4026C8.34918 8.43146 8.32901 8.46515 8.28846 8.53268L6.48768 11.534C5.9736 12.3908 5.71657 12.8191 5.83194 13.0205C5.86693 13.0817 5.91756 13.1323 5.97864 13.1673C6.18003 13.2826 6.60843 13.0257 7.46524 12.5116L10.4666 10.7107C10.534 10.6702 10.5679 10.65 10.5967 10.6239C10.6062 10.6151 10.6154 10.606 10.6241 10.5964C10.6502 10.5676 10.6705 10.5339 10.711 10.4664L12.5117 7.46502ZM9.91909 9.91851C10.151 9.68663 10.151 9.31065 9.91909 9.07878C9.68722 8.84691 9.31124 8.84691 9.07937 9.07878C8.84749 9.31065 8.84749 9.68663 9.07937 9.91851C9.31124 10.1504 9.68722 10.1504 9.91909 9.91851Z"
                                fill="#FFB703"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_30_38484">
                                <rect
                                  width="18.9878"
                                  height="18.9878"
                                  fill="white"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div>
                        <h5 className="ct_fs_18 text-white ct_mb_20">
                          Most popular:
                        </h5>
                        <ul className="ct_most_popular_job_list">
                          <li>
                            <a onClick={() => navigate(enterPrisesPaths?.DesignService)}>UI/UX Design</a>
                          </li>
                          <li>
                            <a>Human Research</a>
                          </li>
                          <li>
                            <a onClick={() => navigate(enterPrisesPaths?.marketing_services)}>Digital Marketing</a>
                          </li>
                          <li>
                            <a>Video & Animation</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="ct_mt_90">
                      <div className="d-flex align-items-center gap-3 justify-content-between ct_mb_40 ct_flex_col_575">
                        <h4 className="ct_fs_36 mb-0 text-white">
                          Recommended Opporturnity
                        </h4>
                        <a
                          className="ct_yellow_btn ct_yellow_btn_text_blue  ct_border_radius_8 ct_h_50 ct_white_nowrap"
                          onClick={() => navigate(coachPaths?.HireTalent)}
                        >
                          Start Hiring
                        </a>
                      </div>

                      <div className="row gx-xl-5">
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div
                            className="ct_opportunity_card"
                            style={{ backgroundColor: "#219EBC" }}
                          >
                            <div>
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 43 43"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.7 7.00113C13.6313 7.00113 11.6474 7.94931 10.1846 9.63709C8.72178 11.3249 7.9 13.614 7.9 16.0008C7.9 18.3877 8.72178 20.6768 10.1846 22.3646C11.6474 24.0524 13.6313 25.0006 15.7 25.0006C17.7687 25.0006 19.7526 24.0524 21.2154 22.3646C22.6782 20.6768 23.5 18.3877 23.5 16.0008C23.5 13.614 22.6782 11.3249 21.2154 9.63709C19.7526 7.94931 17.7687 7.00113 15.7 7.00113ZM11.8 27.2505C9.73131 27.2505 7.74735 28.1987 6.28457 29.8864C4.82178 31.5742 4 33.8633 4 36.2502V38.5001C4 39.6936 4.41089 40.8381 5.14228 41.682C5.87368 42.5259 6.86566 43 7.9 43H23.5C24.5343 43 25.5263 42.5259 26.2577 41.682C26.9891 40.8381 27.4 39.6936 27.4 38.5001V36.2502C27.4 33.8633 26.5782 31.5742 25.1154 29.8864C23.6526 28.1987 21.6687 27.2505 19.6 27.2505H11.8ZM25.9375 22.5369C26.8696 20.602 27.4 18.3745 27.4 16.0008C27.4004 13.7137 26.8972 11.4638 25.9375 9.46255C27.0447 8.25373 28.4347 7.44574 29.9356 7.13844C31.4365 6.83114 32.9825 7.038 34.3826 7.73345C35.7828 8.4289 36.9756 9.58246 37.8137 11.0516C38.6518 12.5207 39.0984 14.2409 39.0984 15.9997C39.0984 17.7585 38.6518 19.4788 37.8137 20.9479C36.9756 22.417 35.7828 23.5705 34.3826 24.266C32.9825 24.9614 31.4365 25.1683 29.9356 24.861C28.4347 24.5537 27.0447 23.7457 25.9375 22.5369ZM30.2587 43C30.9217 41.677 31.3019 40.1403 31.3019 38.5001V36.2502C31.3056 32.9288 30.2443 29.7232 28.3223 27.2505H35.2C37.2687 27.2505 39.2526 28.1987 40.7154 29.8864C42.1782 31.5742 43 33.8633 43 36.2502V38.5001C43 39.6936 42.5891 40.8381 41.8577 41.682C41.1263 42.5259 40.1343 43 39.1 43H30.2587Z"
                                  fill="#8ECAE6"
                                />
                              </svg>
                            </div>
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Talent Ready
                              </h4>
                              <a
                                className="ct_yellow_text"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(coachPaths?.HireTalent);
                                }}
                              >
                                View All{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div
                            className="ct_opportunity_card"
                            style={{ backgroundColor: "#219EBC" }}
                          >
                            <div>
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 39 39"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_30_38515)">
                                  <path
                                    d="M28.1385 22.448L31.811 18.7739C33.1693 17.4159 34.2469 15.8037 34.9822 14.0293C35.7174 12.2549 36.0959 10.3531 36.0961 8.43237V3H30.6637C28.7432 2.99998 26.8414 3.37826 25.067 4.11322C23.2926 4.84818 21.6803 5.92545 20.3222 7.2835L16.6481 10.956L7.4555 9.80713L0.573625 16.689L22.4055 38.5225L29.2874 31.6406L28.1385 22.448ZM25.2265 25.3584L25.8651 30.4658L22.4055 33.9254L19.5325 31.0524L25.2265 25.3584ZM13.7377 13.868L8.04213 19.562L5.17237 16.689L8.632 13.2294L13.7377 13.868ZM8.04213 28.753L2.29775 34.499L0 32.2012L5.74438 26.4569L8.04213 28.753ZM12.6393 33.3517L6.89325 39.0961L4.5955 36.7984L10.3399 31.0524L12.6393 33.3517Z"
                                    fill="#8ECAE6"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_30_38515">
                                    <rect width="39" height="39" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Quick Start
                              </h4>
                              <a
                                className="ct_yellow_text"
                                onClick={(e) => {
                                  e.preventDefault();
                                  openSignUp();
                                }}
                              >
                                Sign Up{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div
                            className="ct_opportunity_card"
                            style={{ backgroundColor: "#219EBC" }}
                          >
                            <div>
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M23.8 0H4.2C1.82 0 0 1.82 0 4.2V23.8C0 26.18 1.82 28 4.2 28H23.8C26.18 28 28 26.18 28 23.8V4.2C28 1.82 26.18 0 23.8 0ZM8.4 21C8.4 21.84 7.84 22.4 7 22.4C6.16 22.4 5.6 21.84 5.6 21V15.4C5.6 14.56 6.16 14 7 14C7.84 14 8.4 14.56 8.4 15.4V21ZM15.4 21C15.4 21.84 14.84 22.4 14 22.4C13.16 22.4 12.6 21.84 12.6 21V7C12.6 6.16 13.16 5.6 14 5.6C14.84 5.6 15.4 6.16 15.4 7V21ZM22.4 21C22.4 21.84 21.84 22.4 21 22.4C20.16 22.4 19.6 21.84 19.6 21V12.6C19.6 11.76 20.16 11.2 21 11.2C21.84 11.2 22.4 11.76 22.4 12.6V21Z"
                                  fill="#8ECAE6"
                                />
                              </svg>
                            </div>
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Smart Budget
                              </h4>
                              <a
                                className="ct_yellow_text"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(coachPaths?.ContactUs, {
                                    state: { data: "landing" },
                                  });
                                }}
                              >
                                Contact Us{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-xl-3 col-lg-3 col-md-6 mb-4 mb-lg-0"
                          data-aos="fade-down"
                          data-aos-duration="1500"
                        >
                          <div
                            className="ct_opportunity_card"
                            style={{ backgroundColor: "#219EBC" }}
                          >
                            <div>
                              <svg
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clip-path="url(#clip0_30_38535)">
                                  <path
                                    d="M20.92 29.2344C20.92 29.5701 20.6591 29.892 20.1947 30.1293C19.7304 30.3667 19.1005 30.5 18.4438 30.5C17.7871 30.5 17.1573 30.3667 16.6929 30.1293C16.2286 29.892 15.9677 29.5701 15.9677 29.2344V8.01962L11.1904 10.6841C10.9705 10.8067 10.7057 10.9059 10.4108 10.9761C10.116 11.0463 9.79696 11.0862 9.47199 11.0934C8.81569 11.1079 8.17494 10.9887 7.69073 10.7617C7.45096 10.6494 7.25685 10.514 7.11946 10.3633C6.98207 10.2126 6.90409 10.0496 6.88999 9.88347C6.86151 9.54802 7.09491 9.22053 7.53885 8.97304L16.6181 3.91065C16.8501 3.78124 17.1322 3.6779 17.4465 3.6072C17.7608 3.53651 18.1004 3.5 18.4438 3.5C18.7872 3.5 19.1269 3.53651 19.4412 3.6072C19.7555 3.6779 20.0376 3.78124 20.2696 3.91065L29.3488 8.97304C29.7927 9.22053 30.0261 9.54802 29.9977 9.88347C29.9692 10.2189 29.6812 10.5348 29.1969 10.7617C28.7127 10.9887 28.072 11.1079 27.4157 11.0934C26.7594 11.0788 26.1413 10.9316 25.6973 10.6841L20.92 8.01962V29.2344ZM-19.5238 27.9688C-20.1806 27.9688 -20.8104 27.8355 -21.2748 27.5981C-21.7391 27.3608 -22 27.0389 -22 26.7032C-22 26.3676 -21.7391 26.0456 -21.2748 25.8083C-20.8104 25.571 -20.1806 25.4376 -19.5238 25.4376H8.53922C9.19594 25.4376 9.82575 25.571 10.2901 25.8083C10.7545 26.0456 11.0154 26.3676 11.0154 26.7032C11.0154 27.0389 10.7545 27.3608 10.2901 27.5981C9.82575 27.8355 9.19594 27.9688 8.53922 27.9688H-19.5238ZM-12.0954 21.6408C-12.0954 22.3394 -10.9861 22.9064 -9.61924 22.9064H8.53922C9.19594 22.9064 9.82575 22.7731 10.2901 22.5357C10.7545 22.2984 11.0154 21.9765 11.0154 21.6408C11.0154 21.3052 10.7545 20.9833 10.2901 20.7459C9.82575 20.5086 9.19594 20.3752 8.53922 20.3752H-9.61924C-10.276 20.3752 -10.9058 20.5086 -11.3701 20.7459C-11.8345 20.9833 -12.0954 21.3052 -12.0954 21.6408ZM0.285378 17.844C-0.37134 17.844 -1.00116 17.7107 -1.46553 17.4733C-1.9299 17.236 -2.19078 16.9141 -2.19078 16.5784C-2.19078 16.2428 -1.9299 15.9209 -1.46553 15.6835C-1.00116 15.4462 -0.37134 15.3128 0.285378 15.3128H8.53922C9.19594 15.3128 9.82575 15.4462 10.2901 15.6835C10.7545 15.9209 11.0154 16.2428 11.0154 16.5784C11.0154 16.9141 10.7545 17.236 10.2901 17.4733C9.82575 17.7107 9.19594 17.844 8.53922 17.844H0.285378Z"
                                    fill="#8ECAE6"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_30_38535">
                                    <rect width="30" height="30" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <div className="ct_mt_30">
                              <h4 className="ct_fs_24_new text-white mb-3">
                                Team Flexibility
                              </h4>
                              <a
                                className="ct_yellow_text"
                                data-bs-target="#share_your_project_modal"
                                data-bs-toggle="modal"
                              >
                                Share your Project{" "}
                                <i class="fa-solid fa-arrow-right ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="ct_py_100 ct_px_40 ct_nuvio_make_smarter_coice_shape">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="ct_fs_40 text-center ct_darkblue_text ct_mb_60">
                      What makes NUVIO the smarter choice?
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div className="ct_py_56">
                      <h4 className="ct_fs_28 mb-3 ct_orange_text ct_text_op_8">
                        Find the right consultants — faster, easier, and with
                        confidence.
                      </h4>
                      <p
                        className="ct_fs_24_new ct_line_h_40 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "663px" }}
                      >
                        NUVIO is designed to help companies connect with
                        qualified freelance IT consultants who are ready to
                        bring real impact to your projects. Whether it’s cloud
                        migration, cybersecurity, data, or software development
                        — NUVIO makes hiring simple and efficient. Why
                        enterprises choose NUVIO:
                      </p>
                      <ul
                        className="ct_mt_20 ps-5 ct_para_scroll ct_custom_scroll"
                        style={{ listStyle: "disc" }}
                      >
                        <li className="ct_fs_22 ct_darkblue_text">
                          Only vetted, experienced consultants
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Fast and accurate matching with the right profiles
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Easy mission posting and direct contact
                        </li>
                        <li className="mt-2 ct_fs_22 ct_darkblue_text">
                          Flexible support for short- or long-term needs
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6  ps-xl-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div className="py-4">
                      <img
                        src="../assets/img/pexels-teona_swift-6913710.png"
                        className="ct_img_h_592"
                      />
                    </div>
                  </div>
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6 "
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div className="ct_minus_mt_40 py-4">
                      <img
                        src="../assets/img/pexels-ketut-subiyanto-4559524.png"
                        className="ct_img_h_592"
                      />
                    </div>
                  </div>
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6  ps-xl-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div className="ct_py_56">
                      <h4 className="ct_fs_28 mb-3 ct_orange_text ct_text_op_8">
                        Experts who think beyond the task
                      </h4>
                      <p
                        className="ct_fs_24_new ct_line_h_40 ct_para_scroll ct_custom_scroll"
                        style={{ maxWidth: "674px" }}
                      >
                        Our consultants don’t just deliver, they advise, guide,
                        and lead. With the NuForge program, NUVIO empowers
                        consultants to position themselves as specialists and
                        thought leaders. You get more than execution you get
                        expertise with vision. What sets our consultants apart:
                      </p>
                      <ul
                        className="ct_mt_20 ps-5 ct_para_scroll ct_custom_scroll"
                        style={{ listStyle: "disc" }}
                      >
                        <li className="ct_fs_24_new ct_darkblue_text">
                          Clear, trustworthy profiles with real experience
                        </li>
                        <li className="mt-2 ct_fs_24_new ct_darkblue_text">
                          Strategic thinking, not just technical skills
                        </li>
                        <li className="mt-2 ct_fs_24_new ct_darkblue_text">
                          Focused on results, innovation, and long-term value
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="ct_px_40  ct_pb_100">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="ct_fs_36 ct_darksky_blue_text text-center mb-0">
                      Discover Exceptional Freelancers
                    </h2>
                  </div>
                </div>
                <div
                  className="row ct_mt_60"
                  data-aos="fade-down"
                  data-aos-duration="1500"
                >
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    slidesPerView={5}
                    autoHeight={false}
                    navigation
                    // autoplay={{ delay: 2500 }}
                    // loop={true}
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      576: { slidesPerView: 2 },
                      768: { slidesPerView: 4 },
                      1200: { slidesPerView: 5 },
                    }}
                    className="ct_coach_created_slider"
                  >
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_4.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                            <p className="mb-0 ct_grey_text">Founder Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_2.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Joe Bridges</h4>
                            <p className="mb-0 ct_grey_text">
                              Leadership Coach
                            </p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_10.png"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Nellie Padilla</h4>
                            <p className="mb-0 ct_grey_text">Personal Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_4.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Jeffrey Walters</h4>
                            <p className="mb-0 ct_grey_text">Founder Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="item">
                        <figure className="ct_featured_coach_card">
                          <div className="ct_featured_card_img">
                            <img
                              src="../assets/img/Featured_Coaches_img_5.jpg"
                              alt=""
                            />
                          </div>
                          <figcaption>
                            <h4 className="ct_fs_20  mb-1">Dean Bell</h4>
                            <p className="mb-0 ct_grey_text">Frontend Coach</p>
                          </figcaption>
                        </figure>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </section>

            <section
              class="ct_looking_for_work_bg      ct_p_111_y_106"
              style={{ backgroundColor: "var(--yellow)" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
                    Unlock Your Potential with Expert Coaching
                  </h4>
                  <p class="mb-0 ct_fs_18" style={{ maxWidth: "500px" }}>
                    Join a community of coaches and hands-on workshops designed
                    to elevate your business.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(coachPaths?.WebinarLandingPage);
                    }}
                  >
                    Get Coached
                  </a>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 ct_py_130">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div
                    class="col-lg-4 mb-4 mb-lg-0 aos-init aos-animate"
                    data-aos="fade-right"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_img">
                      <img
                        src="../assets/img/Rectangle_3_458966.png"
                        alt=""
                        style={{ objectPosition: "left" }}
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-8 mb-4 mb-lg-0 aos-init aos-animate ps-lg-5"
                    data-aos="fade-left"
                    data-aos-duration="1500"
                  >
                    <div class="ct_how_work_content">
                      <h4 class="ct_fs_24 ct_orange_text">We’ve Got You</h4>
                      <h3 class="ct_fs_32 ct_darksky_blue_text ">
                        Need hiring help? We guide every step.
                      </h3>
                    </div>
                    <div class="row mt-5">
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/fluent_person_svg_1.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Talent Strategy Support
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "185px" }}
                            >
                              We assess your needs and recommend the right
                              talent structure for your project.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/qlementine_icons_speaker_svg.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Pre-Built Job Listings
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "208px" }}
                            >
                              Seamlessly manage projects, co-create solutions,
                              and expand your team without friction.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
                        <div class="ct_how_work_card p-3">
                          <img
                            src="../assets/img/famicons_people_svg.png"
                            alt=""
                            className="ct_w_50_340"
                          />
                          <div class="pt-4">
                            <h5 className="ct_fs_20 ct_dakrblue_text mb-4">
                              Curated Talent{" "}
                            </h5>
                            <p
                              class="mb-0 ct_fs_16"
                              style={{ maxWidth: "208px" }}
                            >
                              Get matched with vetted freelancers based on your
                              goals, timelines, and budget.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              class="ct_looking_for_work_bg  ct_looking_for_work_bg_left    ct_p_111_y_106"
              style={{ backgroundColor: "var(--orange)" }}
            >
              <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
                <div class="text-white">
                  <h4 class="ct_fs_36 mb-4 ct_darkblue_text">
                    Built for Your Growth
                  </h4>
                  <p class="mb-0 ct_fs_18" style={{ maxWidth: "632px" }}>
                    Shaped by your insights, our platform evolves with your
                    needs—helping you scale smarter at every stage.
                  </p>
                </div>
                <div class="ct_flex_shrink_0">
                  <a
                    class="ct_yellow_btn ct_darkblue_btn ct_flex_1 px-5"
                    onClick={(e) => {
                      e.preventDefault();
                      openSignUp();
                    }}
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </section>

            <section class=" ct_px_40 pt-0 ct_mt_100 ct_faq_section_shape_yellow ct_faq_section_shape_blue">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-xxl-7 col-xl-7 col-md-6 mb-4 mb-md-0 ">
                    <div class="ct_about_cnt ">
                      <h2 class=" ct_fs_32  mb-4 ct_darksky_blue_text">
                        Frequently asked questions
                      </h2>

                      <div class="ct_faq_question_main ct_faq_question_yellow_plus">
                        <div class="accordion" id="faq_accordionExample">
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faq_one">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_one"
                                aria-expanded="false"
                                aria-controls="collapsefaq_one"
                              >
                                How do I post a job on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_one"
                              class="accordion-collapse collapse"
                              aria-labelledby="faq_one"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Sign up for an account, complete your profile,
                                  and browse our directory of coaches. You can
                                  filter by expertise, experience, and coaching
                                  style to find the best match for your needs.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqtwo">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Two"
                                aria-expanded="true"
                                aria-controls="collapseTwo"
                              >
                                What kind of talent can I find on NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Two"
                              class="accordion-collapse collapse "
                              aria-labelledby="faqtwo"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  NUVIO offers a wide range of coaching,
                                  including career coaching, business and
                                  entrepreneurship coaching, creative and design
                                  coaching, personal development, and
                                  skills-specific coaching like Creative AI or
                                  freelance growth.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqthree">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Three"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Three"
                              >
                                How does NUVIO match talent to my job post?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Three"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqthree"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Once you’ve found a coach that fits your
                                  needs, you can book a session directly through
                                  their profile. Choose a time that works for
                                  you, confirm your booking, and receive a
                                  session link or meeting details.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFour">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Four"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Four"
                              >
                                Can I hire for long-term or short-term roles?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Four"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFour"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Review the coach’s profile, experience, and
                                  specialties. Many coaches offer introductory
                                  calls or discovery sessions so you can assess
                                  compatibility before committing to a full
                                  program.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqFive">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Five"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Five"
                              >
                                What if the freelancer isn’t a good fit?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Five"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqFive"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqSix">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Six"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Six"
                              >
                                Can I communicate directly with freelancers
                                before hiring?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Six"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqSix"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqSeven">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Seven"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Seven"
                              >
                                Can I hire multiple freelancers for the same
                                project?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Seven"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqSeven"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                          <div class="accordion-item">
                            <h2 class="accordion-header" id="faqEight">
                              <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsefaq_Eight"
                                aria-expanded="false"
                                aria-controls="collapsefaq_Eight"
                              >
                                What’s the cost of using NUVIO?
                              </button>
                            </h2>
                            <div
                              id="collapsefaq_Eight"
                              class="accordion-collapse collapse"
                              aria-labelledby="faqEight"
                              data-bs-parent="#faq_accordionExample"
                            >
                              <div class="accordion-body">
                                <p class="ct_fs_20 mb-3 ct_line_h_30">
                                  Yes! You can send a message or schedule a
                                  short consultation to discuss your goals and
                                  see if the coach is the right fit before
                                  booking a full session.
                                </p>
                                {/* <p class="ct_fs_20 mb-0 ct_line_h_30">
                            If you’re doing something new, on a bigger scale, or
                            need more flexibility, then Builder Studio is for
                            you. Prices vary depending on the features you need
                            but again, you’ll know exactly what you’re paying
                            upfront.
                          </p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xxl-5  col-xl-5 col-md-6 mb-4 mb-md-0 ps-xl-5  ">
                    <div class="ct_about_img ct_mb_100">
                      <img
                        src="../assets/img/hire_talent_faq_right_img_345.png"
                        class="ct_img_h_579"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}
            </section>
          </>
        )}
      </MenuLayout>

      <div
        className="modal modal-xl  ct_congratulation_modal_fade"
        id="share_your_project_modal"
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered ct_modal-dialog"
          style={{ maxWidth: "764px" }}
        >
          <div className="modal-content">
            <div className="modal-header pb-0 border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body px-sm-5 px-3 pt-0 pb-5">
              <h4 className="ct_fs_32 ct_darkblue_text mb-4">Get a Quote</h4>
              <div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14  ct_darkblue_text mb-2">
                        Name
                      </label>
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input px-2 ct_h_60">
                          <option>Select</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14  ct_darkblue_text mb-2">
                        Work E-mail
                      </label>
                      <div className="d-flex flex-column gap-2 position-relative">
                        <select className="form-control ct_input px-2 ct_h_60">
                          <option>Select</option>
                        </select>
                        <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="ct_fs_14  ct_darkblue_text mb-2">
                      Select Services
                    </label>
                    <div className="row">
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                            placeholder="Mobile Design"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                            placeholder="Website Design"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                            placeholder="Marketing"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                            placeholder="Customer Service"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group mb-4">
                      <label className="ct_fs_14  ct_darkblue_text mb-2">
                        Tell Us About Your Project
                      </label>
                      <textarea
                        className="form-control ct_input px-2 h-auto"
                        rows={4}
                        placeholder="Mobile Design"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="ct_fs_14  ct_darkblue_text mb-2">
                      What is your budget?
                    </label>
                    <div className="row">
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                          />
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="form-group mb-4">
                          <input
                            type="text"
                            className="form-control ct_input text-center px-2 ct_h_60"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-4 px-3">
                  <button
                    className="ct_yellow_btn w-100"
                    data-bs-target="#ct_submit_modal"
                    data-bs-toggle="modal"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade ct_submit_modal"
        id="ct_submit_modal"
        tabindex="-1"
        aria-labelledby="ct_submit_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header pb-0 border-0">
              <button
                type="button"
                className="btn-close ct_circle_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body pb-5">
              <div className="mx-auto d-block text-center mb-4">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.57031 26.2087V45.4912H42.4328V26.2087L24.0016 35.3737L5.57031 26.2087Z"
                    fill="#FFB703"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.57031 18.135V23.265L24.0016 32.4263L42.4328 23.265V18.135H5.57031Z"
                    fill="#FFB703"
                  />
                  <path
                    d="M23.9436 23.355L15.0898 11.2725H20.6136V0H27.2211V11.2725H32.8011L23.9436 23.355Z"
                    fill="#FB8500"
                  />
                </svg>
              </div>
              <div className="text-center">
                <h4 className="ct_fs_20">Thanks for Reaching Out</h4>
                <p className="mx-auto" style={{ maxWidth: "348px" }}>
                  We've received your request for a quote and our team is
                  already reviewing your details. You can expect a response
                  within 24-48 hours with a tailored estimate and next steps.
                </p>
              </div>
              <div className="text-center mt-4 d-flex align-items-center gap-3 justify-content-center ct_flex_col_575 ct_w_100_575">
                <button
                  className="ct_yellow_btn ct_h_48 px-5 w-100"
                  data-bs-dismiss="modal"
                >
                  Explore More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchTalent;
